<template>
  <div>
    <div class="container">
      <div class="title">账号设置>编辑邮箱</div>
      <div class="bottom">

        <a-alert message="验证邮箱，修改成功后新邮箱将同步至简历" banner />
        
        <!-- 表单 -->
    <a-form-model
    ref="ruleForm"
    :model="form"
    :rules="rules"
    :label-col="labelCol"
    :wrapper-col="wrapperCol"
    >
    <a-form-model-item ref="youxiang" label="请输入常用邮箱" prop="youxiang">
      <a-input
        v-model="form.youxiang"
        :maxLength="20"
      />
    </a-form-model-item>
    </a-form-model>

      <div class="btns">
        <button class="qued" @click="updateEmail('ruleForm')">确定</button>
        <button class="qux" @click="$router.back()">取消</button>
      </div>
        
      </div>
    </div>
  </div>
</template>


<script>
export default {
  data(){
    //电子邮箱
    let validateDzyx = (rule, value, callback) => {
      var reg = /\w[-\w.+]*@([A-Za-z0-9][-A-Za-z0-9]+\.)+[A-Za-z]{2,14}/;
      if (!reg.test(value)) {
        callback(new Error('电子邮箱格式错误'));
      }else{
        callback();
      }
    }
    return{
      labelCol: { span: 8 },
      wrapperCol: { span: 14 },

      form:{
        youxiang:''
      },

      //校验规则
       rules: {
        youxiang: [
          { required: true, message: '请输入邮箱', trigger: 'blur' },
          { validator: validateDzyx, trigger: 'blur' }
        ],
      }
    }
  },

  methods:{
    // 获取当前用户邮箱
    // getByIDEmail(){
    //   this.post({
    //     url: 'getByIDEmail',
    //   }, (res) => {
    //     this.form.youxiang=res.data[0].EMAIL
    //   })
    // },

    //修改了邮箱
    updateEmail(ruleForm){
      this.$refs[ruleForm].validate(v=>{
        if(!v) return this.$message.warning('请输入正确的邮箱格式')
         this.post({
          url: 'updateEmail',
          data:{
            newEmail:this.form.youxiang
          }
          }, (res) => {
            console.log(res);
            if(res.code!==200) return this.$message.error(res.message)
            if(res.code===200){
              this.$message.success('更新邮箱成功')
            }
          })
      })
     
    }
  },

  created(){
    // this.getByIDEmail()
  }
}
</script>


<style scoped>
.container{
  width: 100%;
  height: 320px;
  background-color: #fff;
  margin: 20px auto;
}

.title{
  height: 40px;
  border-bottom: 1px solid #DFE7EA;
  background: #ffffff;
  padding-left: 44px;
  line-height: 40px;
  position: relative;
}


.btns{
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 50px;
}

.qued{
  background: #F06B42;
  color: #ffffff;
  border: 0;
}

.qux{
  background: #F0F8FB;
  color: #86878B;
  border: 1px solid #86878B;
}

.btns button{
  width: 111px;
  height: 43px;
  border-radius: 5px;
  font-size: 20px;
  margin-left: 20px;
}

.bottom{
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}


/deep/ .ant-form{
  margin-top: 30px;
  margin-bottom: 20px;
}

/deep/ .ant-input{
  width: 460px;
  height: 40px;
  color: #C5C5C5;
  font-weight: bold;
  background: #CBEFFF;
  border-left: 2px solid #169CDB;
  border-top: 2px solid #DFE7EA;
  border-bottom: 2px solid #DFE7EA;
  border-right: 2px solid #DFE7EA;
  font-size: 20px;
}

/deep/ .ant-form-item label {
    position: relative;
    left: -60px;
}

/deep/ .ant-form-item{
  margin-left: -160px;
}
</style>


// WEBPACK FOOTER //
// src/views/grzx/pages/bjyx.vue